module.exports = __webpack_public_path__ + "static/media/Apple-Macbook-Gold.deff7105.png";